import "./SortDesigns.scss";
import { useRef } from "react";
import { useOnClickOutside } from "usehooks-ts";
import { SortOption } from "../pages/Designs";
import { ArrowDownOutlined, ArrowUpOutlined, CheckOutlined, ClockCircleOutlined, DownOutlined } from "@ant-design/icons";

export interface SortDesignsMenuProps {
  currentSort: SortOption;
  sortDesigns: (sort: SortOption) => void;
  mobile: boolean;
  closeMenu: () => void;
}

export default function SortDesignsMenu({
  currentSort,
  sortDesigns,
  mobile,
  closeMenu
}: SortDesignsMenuProps) {
  const ref = useRef(null);

  const handleClickOutside = (ev: MouseEvent) => {
    closeMenu();
  }

  useOnClickOutside(ref, (ev) => handleClickOutside(ev as MouseEvent));

  function sortDesignsClick(option: SortOption) {
    sortDesigns(option);
    closeMenu();
  }

  return (
    <div className={"sort-designs-menu"} ref={ref}>
      {mobile &&
      <div className="cat-header">
        <span>Category</span>
        <DownOutlined onClick={() => closeMenu()}/>
      </div>}
      <ul>
        <li className={currentSort === SortOption.EditedRecent ? 'active' : ''} onClick={() => sortDesignsClick(SortOption.EditedRecent)}>
          <ClockCircleOutlined/> Recently Edited
          {currentSort === SortOption.EditedRecent && <CheckOutlined/>}
        </li>
        <li className={currentSort === SortOption.EditedRecentReverse ? 'active' : ''}  onClick={() => sortDesignsClick(SortOption.EditedRecentReverse)}>
          <ClockCircleOutlined/> Oldest Edited
          {currentSort === SortOption.EditedRecentReverse && <CheckOutlined/>}
        </li>
        <li className={currentSort === SortOption.NameAZ ? 'active' : ''}  onClick={() => sortDesignsClick(SortOption.NameAZ)}>
          <ArrowUpOutlined/> Alphabetical (A-Z)
          {currentSort === SortOption.NameAZ && <CheckOutlined/>}
        </li>
        <li className={currentSort === SortOption.NameZA ? 'active' : ''}  onClick={() => sortDesignsClick(SortOption.NameZA)}>
          <ArrowDownOutlined/> Alphabetical (Z-A)
          {currentSort === SortOption.NameZA && <CheckOutlined/>}
        </li>
      </ul>
    </div>
  );
}
